import React, { createContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import PropTypes from 'prop-types';

import isValidUrl from 'src/utils/isValidUrl';

const initialUserData = {};

const UserContext = createContext({
  user: { ...initialUserData }
});

export const UserProvider = ({ children }) => {
  const { user } = useAuth0();
  const userData = user
    ? Object.keys(user).reduce((obj, key) => {
        if (isValidUrl(key)) {
          const url = new URL(key);
          obj[url.pathname.replace(/\//g, '')] = user[key];
        } else {
          obj[key] = user[key];
        }
        return obj;
      }, {})
    : { ...initialUserData };

  // Check if user has family_name, if yes, set name to family_name
  if (userData.family_name) {
    userData.name = `${userData.family_name} ${userData.given_name}`;
  }

  return (
    <UserContext.Provider value={{ user: { ...userData } }}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default UserContext;
